module.exports = {
  "zones": {
    "Atlantic/Reykjavik": ["z", {
      "wallclock": -54774000000,
      "format": "GMT",
      "abbrev": "GMT",
      "offset": 0,
      "posix": -54770400000,
      "save": 0
    }, {
      "wallclock": -1956614400000,
      "format": "-01/+00",
      "abbrev": "-01",
      "offset": -3600000,
      "posix": -1956609120000,
      "save": 0,
      "rules": "Iceland"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -5280000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Iceland": [{
      "from": 1947,
      "to": 1967,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1967,
      "month": 9,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1966,
      "month": 9,
      "day": [0, 22],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1949,
      "month": 9,
      "day": [7, 30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1948,
      "month": 9,
      "day": [0, 22],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1946,
      "month": 2,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1942,
      "month": 2,
      "day": [0, 2],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1941,
      "month": 10,
      "day": [0, 2],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 1,
      "day": [7, 25],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 3,
      "day": [7, 29],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 9,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 19],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 5,
      "day": [7, 23],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1917,
      "to": 1919,
      "month": 1,
      "day": [7, 19],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 10,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1917,
      "to": 1917,
      "month": 9,
      "day": [7, 21],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};